import React, { useEffect } from 'react';
import { useState } from "@hookstate/core"
import hive from "./index"
import { Favorite, FavoriteBorder } from '@material-ui/icons';

function numberWithSpaces(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}


function InfoCard() {
  const { infoCard, totalWidth, height, mainColor, typeColors, favoriteList } = useState(hive.state)
  const lot = infoCard.get()

  useEffect(() => {
  })

  return <div style={{
    position: "absolute",
    width: "20vw",
    left: "80vw",
    height: height.get(),
    zIndex: 3,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    pointerEvents: "none",
  }}> {lot &&

    <div style={{
      width: "100%",
      // height: height.get() * 0.3 + "px",
      background: "#f1f1f1",
      boxShadow: `-${height.get() * 0.005}px ${height.get() * 0.005}px ${height.get() * 0.01}px 0px rgba(0,0,0,0.15)`,
      display: "flex",
      justifyContent: "center",
      pointerEvents: "initial",
    }}>
      <div style={{
        left: -height.get() * 0.045 * 0.5 + "px",
        marginTop: -height.get() * 0.045 * 0.5 + "px",
        position: "absolute",
        width: height.get() * 0.045 + "px",
        height: height.get() * 0.045 + "px",
        borderRadius: height.get() * 0.045 * 0.5 + "px",
        backgroundColor: "#3b99fc",
        backgroundImage: "url(/gui/i.png)",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "40%",
      }}>
      </div>
      <div style={{
        width: "80%",
      }}>
        <div style={{
          // fontFamily: 'MuktaBold',
          fontSize: height.get() * 0.03 + "px",
          color: "#9f9f9f",
          height: height.get() * 0.07 + "px",
          lineHeight: height.get() * 0.07 + "px",
          borderBottom: "1px solid #d8d8d8",
          display: "flex",
          justifyContent: "space-between",
        }}>
          <div>
            Lot : {lot.id}
          </div>
          <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}>
            <div style={{
              background: "white",
              border: `0.5px solid #${mainColor.get()}`,
              height: height.get() * 0.04 + "px",
              lineHeight: height.get() * 0.04 + "px",
              width: height.get() * 0.04 + "px",
              borderRadius: height.get() * 0.04 * 0.5 + "px",
              display: "flex",
              justifyContent: "center",
              cursor: "pointer",
            }}>
              <div style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                color: "#ff0057",
              }}>
                <div
                  onClick={() => {
                    hive.toggleFavorite(lot.id)
                  }
                  }
                  style={{
                    height: height.get() * 0.03 + "px"
                  }}>
                  {!favoriteList.find((e) => e.get() === lot.id) &&
                    <FavoriteBorder style={{
                      width: height.get() * 0.025 + "px",
                      height: height.get() * 0.025 + "px",
                    }}></FavoriteBorder>
                  }
                  {favoriteList.find((e) => e.get() === lot.id) &&
                    <Favorite style={{
                      width: height.get() * 0.025 + "px",
                      height: height.get() * 0.025 + "px",
                    }}></Favorite>
                  }

                </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{
          // fontFamily: 'MuktaBold',
          fontSize: height.get() * 0.02 + "px",
          color: "#9f9f9f",
          height: height.get() * 0.07 + "px",
          lineHeight: height.get() * 0.07 + "px",
          borderBottom: "1px solid #d8d8d8",
          display: "flex",
          justifyContent: "space-between"
        }}>
          <div style={{
            width: "40%",
            display: "flex",
          }}>
            <div>
              Type
            </div>
            <div style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center"
            }}>
              <div style={{
                height: height.get() * 0.035 + "px",
                width: height.get() * 0.035 + "px",
                lineHeight: height.get() * 0.035 + "px",
                borderRadius: height.get() * 0.035 * 0.5 + "px",
                textAlign: "center",
                background: `rgb(${typeColors.get()[lot.type - 1][0]},${typeColors.get()[lot.type - 1][1]},${typeColors.get()[lot.type - 1][2]})`,
                marginLeft: height.get() * 0.035 * 0.5,
                color: "white",
              }}>
                T{lot.type}
              </div>
            </div>
          </div>
          <div style={{
            width: "50%",
          }}>
            Surf : {lot.surface} m2
          </div>
          <div style={{
            width: "10%"
          }}>
          </div>
        </div>

        <div style={{
          fontFamily: 'MuktaBold',
          fontSize: height.get() * 0.025 + "px",
          color: `#${mainColor.get()}`,
          height: height.get() * 0.07 + "px",
          lineHeight: height.get() * 0.07 + "px",
          // borderBottom: "1px solid #d8d8d8",
        }}>
          {lot.price && <>
            Prix : {numberWithSpaces(lot.price)}€
          </>
          }
          {/* {!lot.price && <>
            <br/>
          </>
          } */}

        </div>

      </div>
    </div>
    }
  </div>
}

export default InfoCard